module.exports = __webpack_public_path__ + "static/img/reject.dd00ac25.svg";